export default __webpack_public_path__ + "static/media/947-9472283_join-us-illustration.30d60bca.png";